import React, { useState, useEffect } from 'react';

// Edit Modal Component
export const EditModal = ({ item, type, merchants, categories, areas, allItems, onSave, onClose, isDarkMode }) => {
  const [formData, setFormData] = useState(item);

  const renderFields = () => {
    switch (type) {
      case 'merchants':
        return (
          <>
            <div>
              <label className={`block font-medium mb-2 ${isDarkMode ? 'text-gray-300' : 'text-gray-700'}`}>Avatar (Emoji)</label>
              <input
                type="text"
                value={formData.avatar || ''}
                onChange={(e) => setFormData({ ...formData, avatar: e.target.value })}
                className={`w-full px-4 py-2 rounded-lg border ${isDarkMode ? 'bg-gray-700 border-gray-600 text-white' : 'bg-white border-gray-300'}`}
                placeholder="👤"
              />
            </div>
            <div>
              <label className={`block font-medium mb-2 ${isDarkMode ? 'text-gray-300' : 'text-gray-700'}`}>Name</label>
              <input
                type="text"
                value={formData.name || ''}
                onChange={(e) => setFormData({ ...formData, name: e.target.value })}
                className={`w-full px-4 py-2 rounded-lg border ${isDarkMode ? 'bg-gray-700 border-gray-600 text-white' : 'bg-white border-gray-300'}`}
              />
            </div>
            <div>
              <label className={`block font-medium mb-2 ${isDarkMode ? 'text-gray-300' : 'text-gray-700'}`}>Specialty</label>
              <input
                type="text"
                value={formData.specialty || ''}
                onChange={(e) => setFormData({ ...formData, specialty: e.target.value })}
                className={`w-full px-4 py-2 rounded-lg border ${isDarkMode ? 'bg-gray-700 border-gray-600 text-white' : 'bg-white border-gray-300'}`}
              />
            </div>
            <div>
              <label className={`block font-medium mb-2 ${isDarkMode ? 'text-gray-300' : 'text-gray-700'}`}>Greeting (English)</label>
              <textarea
                value={formData.greeting_english || ''}
                onChange={(e) => setFormData({ ...formData, greeting_english: e.target.value })}
                rows="2"
                className={`w-full px-4 py-2 rounded-lg border ${isDarkMode ? 'bg-gray-700 border-gray-600 text-white' : 'bg-white border-gray-300'}`}
              />
            </div>
            <div>
              <label className={`block font-medium mb-2 ${isDarkMode ? 'text-gray-300' : 'text-gray-700'}`}>Greeting (Darija)</label>
              <textarea
                value={formData.greeting_darija || ''}
                onChange={(e) => setFormData({ ...formData, greeting_darija: e.target.value })}
                rows="2"
                className={`w-full px-4 py-2 rounded-lg border ${isDarkMode ? 'bg-gray-700 border-gray-600 text-white' : 'bg-white border-gray-300'}`}
              />
            </div>
            <div className="flex items-center">
              <input
                type="checkbox"
                checked={formData.is_active !== false}
                onChange={(e) => setFormData({ ...formData, is_active: e.target.checked })}
                className="w-5 h-5 mr-2"
              />
              <label className={`font-medium ${isDarkMode ? 'text-gray-300' : 'text-gray-700'}`}>Active</label>
            </div>
            <div className={`mt-4 p-3 rounded-lg ${isDarkMode ? 'bg-gray-900 border-gray-700' : 'bg-blue-50 border-blue-200'} border`}>
              <h4 className={`font-bold mb-2 text-sm ${isDarkMode ? 'text-blue-300' : 'text-blue-800'}`}>💬 Merchant-Specific Bargaining</h4>
              <div className="space-y-2">
                <div>
                  <label className={`block text-xs mb-1 ${isDarkMode ? 'text-gray-300' : 'text-gray-700'}`}>Min Discount %</label>
                  <input
                    type="number"
                    value={formData.discount_min || 10}
                    onChange={(e) => setFormData({ ...formData, discount_min: parseInt(e.target.value) })}
                    min="0"
                    max="100"
                    className={`w-full px-2 py-1 rounded border text-sm ${isDarkMode ? 'bg-gray-700 border-gray-600 text-white' : 'bg-white border-gray-300'}`}
                  />
                </div>
                <div>
                  <label className={`block text-xs mb-1 ${isDarkMode ? 'text-gray-300' : 'text-gray-700'}`}>Max Discount %</label>
                  <input
                    type="number"
                    value={formData.discount_max || 35}
                    onChange={(e) => setFormData({ ...formData, discount_max: parseInt(e.target.value) })}
                    min="0"
                    max="100"
                    className={`w-full px-2 py-1 rounded border text-sm ${isDarkMode ? 'bg-gray-700 border-gray-600 text-white' : 'bg-white border-gray-300'}`}
                  />
                </div>
              </div>
            </div>
            {/* New Game Fields */}
            <div className={`mt-4 p-3 rounded-lg ${isDarkMode ? 'bg-gray-900 border-gray-700' : 'bg-green-50 border-green-200'} border`}>
              <h4 className={`font-bold mb-2 text-sm ${isDarkMode ? 'text-green-300' : 'text-green-800'}`}>🗺️ Game Map & Personality</h4>
              <div className="space-y-2">
                <div>
                  <label className={`block text-xs mb-1 ${isDarkMode ? 'text-gray-300' : 'text-gray-700'}`}>Image URL (avatar photo)</label>
                  <input
                    type="text"
                    value={formData.image_url || ''}
                    onChange={(e) => setFormData({ ...formData, image_url: e.target.value })}
                    className={`w-full px-2 py-1 rounded border text-sm ${isDarkMode ? 'bg-gray-700 border-gray-600 text-white' : 'bg-white border-gray-300'}`}
                    placeholder="https://dl.dropboxusercontent.com/..."
                  />
                  {formData.image_url && (
                    <img src={formData.image_url} alt="Preview" className="h-12 w-12 mt-1 rounded-full object-cover border" />
                  )}
                </div>
                <div>
                  <label className={`block text-xs mb-1 ${isDarkMode ? 'text-gray-300' : 'text-gray-700'}`}>Personality</label>
                  <select
                    value={formData.personality || ''}
                    onChange={(e) => setFormData({ ...formData, personality: e.target.value })}
                    className={`w-full px-2 py-1 rounded border text-sm ${isDarkMode ? 'bg-gray-700 border-gray-600 text-white' : 'bg-white border-gray-300'}`}
                  >
                    <option value="">Not set</option>
                    <option value="friendly">Friendly</option>
                    <option value="tough">Tough</option>
                    <option value="tricky">Tricky</option>
                    <option value="generous">Generous</option>
                  </select>
                </div>
                <div>
                  <label className={`block text-xs mb-1 ${isDarkMode ? 'text-gray-300' : 'text-gray-700'}`}>Souk Area <span className="text-gray-400">(Missions only)</span></label>
                  <select
                    value={formData.area_id || ''}
                    onChange={(e) => setFormData({ ...formData, area_id: e.target.value })}
                    className={`w-full px-2 py-1 rounded border text-sm ${isDarkMode ? 'bg-gray-700 border-gray-600 text-white' : 'bg-white border-gray-300'}`}
                  >
                    <option value="">Not assigned</option>
                    {(areas || []).map(a => (
                      <option key={a.id} value={a.id}>{a.icon || ''} {a.name || a.id}</option>
                    ))}
                  </select>
                </div>
                <div>
                  <label className={`block text-xs mb-1 ${isDarkMode ? 'text-gray-300' : 'text-gray-700'}`}>Callout Text (what they shout on the map)</label>
                  <input
                    type="text"
                    value={formData.callout_text || ''}
                    onChange={(e) => setFormData({ ...formData, callout_text: e.target.value })}
                    className={`w-full px-2 py-1 rounded border text-sm ${isDarkMode ? 'bg-gray-700 border-gray-600 text-white' : 'bg-white border-gray-300'}`}
                    placeholder="Aji aji! Best djellabas here!"
                  />
                </div>
                <div className="grid grid-cols-3 gap-2">
                  <div>
                    <label className={`block text-xs mb-1 ${isDarkMode ? 'text-gray-300' : 'text-gray-700'}`}>Mood Sensitivity (1-10)</label>
                    <input
                      type="number"
                      value={formData.mood_sensitivity || 5}
                      onChange={(e) => setFormData({ ...formData, mood_sensitivity: parseInt(e.target.value) })}
                      min="1" max="10"
                      className={`w-full px-2 py-1 rounded border text-sm ${isDarkMode ? 'bg-gray-700 border-gray-600 text-white' : 'bg-white border-gray-300'}`}
                    />
                  </div>
                  <div>
                    <label className={`block text-xs mb-1 ${isDarkMode ? 'text-gray-300' : 'text-gray-700'}`}>Walk-Away Success %</label>
                    <input
                      type="number"
                      value={formData.walk_away_success_rate || 50}
                      onChange={(e) => setFormData({ ...formData, walk_away_success_rate: parseInt(e.target.value) })}
                      min="0" max="100"
                      className={`w-full px-2 py-1 rounded border text-sm ${isDarkMode ? 'bg-gray-700 border-gray-600 text-white' : 'bg-white border-gray-300'}`}
                    />
                  </div>
                  <div>
                    <label className={`block text-xs mb-1 ${isDarkMode ? 'text-gray-300' : 'text-gray-700'}`}>Start Price x</label>
                    <input
                      type="number"
                      step="0.1"
                      value={formData.start_price_multiplier || 1.0}
                      onChange={(e) => setFormData({ ...formData, start_price_multiplier: parseFloat(e.target.value) })}
                      min="1.0" max="3.0"
                      className={`w-full px-2 py-1 rounded border text-sm ${isDarkMode ? 'bg-gray-700 border-gray-600 text-white' : 'bg-white border-gray-300'}`}
                    />
                  </div>
                </div>
              </div>
            </div>
          </>
        );

      case 'categories':
        return (
          <>
            <div>
              <label className={`block font-medium mb-2 ${isDarkMode ? 'text-gray-300' : 'text-gray-700'}`}>Category ID</label>
              <input
                type="text"
                value={formData.id || ''}
                onChange={(e) => setFormData({ ...formData, id: e.target.value.toLowerCase().replace(/\s+/g, '_') })}
                className={`w-full px-4 py-2 rounded-lg border ${isDarkMode ? 'bg-gray-700 border-gray-600 text-white' : 'bg-white border-gray-300'}`}
                placeholder="e.g., bags, jewelry, hats"
              />
              <p className={`text-xs mt-1 ${isDarkMode ? 'text-gray-400' : 'text-gray-500'}`}>Unique identifier (lowercase, no spaces)</p>
            </div>
            <div>
              <label className={`block font-medium mb-2 ${isDarkMode ? 'text-gray-300' : 'text-gray-700'}`}>Category Name</label>
              <input
                type="text"
                value={formData.name || ''}
                onChange={(e) => setFormData({ ...formData, name: e.target.value })}
                className={`w-full px-4 py-2 rounded-lg border ${isDarkMode ? 'bg-gray-700 border-gray-600 text-white' : 'bg-white border-gray-300'}`}
                placeholder="e.g., Bags, Jewelry, Hats"
              />
            </div>
            <div>
              <label className={`block font-medium mb-2 ${isDarkMode ? 'text-gray-300' : 'text-gray-700'}`}>Icon (Emoji)</label>
              <input
                type="text"
                value={formData.icon || '📁'}
                onChange={(e) => setFormData({ ...formData, icon: e.target.value })}
                className={`w-full px-4 py-2 rounded-lg border ${isDarkMode ? 'bg-gray-700 border-gray-600 text-white' : 'bg-white border-gray-300'}`}
                placeholder="📁"
              />
            </div>
            <div>
              <label className={`block font-medium mb-2 ${isDarkMode ? 'text-gray-300' : 'text-gray-700'}`}>Display Order</label>
              <input
                type="number"
                value={formData.order || 0}
                onChange={(e) => setFormData({ ...formData, order: parseInt(e.target.value) })}
                className={`w-full px-4 py-2 rounded-lg border ${isDarkMode ? 'bg-gray-700 border-gray-600 text-white' : 'bg-white border-gray-300'}`}
                placeholder="0"
              />
              <p className={`text-xs mt-1 ${isDarkMode ? 'text-gray-400' : 'text-gray-500'}`}>Lower numbers appear first</p>
            </div>
          </>
        );
      
      case 'items':
        return (
          <>
            <div>
              <label className={`block font-medium mb-2 ${isDarkMode ? 'text-gray-300' : 'text-gray-700'}`}>Icon (Emoji or leave empty if using Image URL)</label>
              <input
                type="text"
                value={formData.icon || ''}
                onChange={(e) => setFormData({ ...formData, icon: e.target.value })}
                className={`w-full px-4 py-2 rounded-lg border ${isDarkMode ? 'bg-gray-700 border-gray-600 text-white' : 'bg-white border-gray-300'}`}
                placeholder="👕"
              />
            </div>
            <div>
              <label className={`block font-medium mb-2 ${isDarkMode ? 'text-gray-300' : 'text-gray-700'}`}>Name (English)</label>
              <input
                type="text"
                value={formData.name_english || ''}
                onChange={(e) => setFormData({ ...formData, name_english: e.target.value })}
                className={`w-full px-4 py-2 rounded-lg border ${isDarkMode ? 'bg-gray-700 border-gray-600 text-white' : 'bg-white border-gray-300'}`}
              />
            </div>
            <div>
              <label className={`block font-medium mb-2 ${isDarkMode ? 'text-gray-300' : 'text-gray-700'}`}>Name (Darija)</label>
              <input
                type="text"
                value={formData.name_darija || ''}
                onChange={(e) => setFormData({ ...formData, name_darija: e.target.value })}
                className={`w-full px-4 py-2 rounded-lg border ${isDarkMode ? 'bg-gray-700 border-gray-600 text-white' : 'bg-white border-gray-300'}`}
              />
            </div>
            <div>
              <label className={`block font-medium mb-2 ${isDarkMode ? 'text-gray-300' : 'text-gray-700'}`}>Name (Arabic Script)</label>
              <input
                type="text"
                value={formData.name_arabic || ''}
                onChange={(e) => setFormData({ ...formData, name_arabic: e.target.value })}
                className={`w-full px-4 py-2 rounded-lg border ${isDarkMode ? 'bg-gray-700 border-gray-600 text-white' : 'bg-white border-gray-300'}`}
                placeholder="e.g., قميجة"
                dir="rtl"
              />
            </div>
            <div>
              <label className={`block font-medium mb-2 ${isDarkMode ? 'text-gray-300' : 'text-gray-700'}`}>Pronunciation (optional)</label>
              <input
                type="text"
                value={formData.pronunciation || ''}
                onChange={(e) => setFormData({ ...formData, pronunciation: e.target.value })}
                className={`w-full px-4 py-2 rounded-lg border ${isDarkMode ? 'bg-gray-700 border-gray-600 text-white' : 'bg-white border-gray-300'}`}
                placeholder="e.g., qmija"
              />
            </div>
            <div>
              <label className={`block font-medium mb-2 ${isDarkMode ? 'text-gray-300' : 'text-gray-700'}`}>Audio URL (optional - for Dress-Up Avatar learning)</label>
              <input
                type="text"
                value={formData.audio_url || ''}
                onChange={(e) => setFormData({ ...formData, audio_url: e.target.value })}
                className={`w-full px-4 py-2 rounded-lg border ${isDarkMode ? 'bg-gray-700 border-gray-600 text-white' : 'bg-white border-gray-300'}`}
                placeholder="https://example.com/audio.mp3"
              />
              {formData.audio_url && (
                <div className="mt-2">
                  <audio controls className="w-full h-8">
                    <source src={formData.audio_url} />
                  </audio>
                </div>
              )}
            </div>
            <div>
              <label className={`block font-medium mb-2 ${isDarkMode ? 'text-gray-300' : 'text-gray-700'}`}>Category</label>
              <select
                value={formData.category || ''}
                onChange={(e) => setFormData({ ...formData, category: e.target.value })}
                className={`w-full px-4 py-2 rounded-lg border ${isDarkMode ? 'bg-gray-700 border-gray-600 text-white' : 'bg-white border-gray-300'}`}
              >
                {(categories && categories.length > 0) ? (
                  categories.map(cat => (
                    <option key={cat.id} value={cat.id}>{cat.name}</option>
                  ))
                ) : (
                  <>
                    <option value="tops">Tops</option>
                    <option value="bottoms">Bottoms</option>
                    <option value="shoes">Shoes</option>
                    <option value="accessories">Accessories</option>
                    <option value="outerwear">Outerwear</option>
                  </>
                )}
              </select>
            </div>
            <div>
              <label className={`block font-medium mb-2 ${isDarkMode ? 'text-gray-300' : 'text-gray-700'}`}>Gender</label>
              <select
                value={formData.gender || 'unisex'}
                onChange={(e) => setFormData({ ...formData, gender: e.target.value })}
                className={`w-full px-4 py-2 rounded-lg border ${isDarkMode ? 'bg-gray-700 border-gray-600 text-white' : 'bg-white border-gray-300'}`}
              >
                <option value="male">Male</option>
                <option value="female">Female</option>
                <option value="unisex">Unisex</option>
              </select>
            </div>
            <div>
              <label className={`block font-medium mb-2 ${isDarkMode ? 'text-gray-300' : 'text-gray-700'}`}>Base Price (Tokens)</label>
              <input
                type="number"
                value={formData.base_price_tokens || formData.base_price_dh || 0}
                onChange={(e) => setFormData({ ...formData, base_price_tokens: parseInt(e.target.value) })}
                className={`w-full px-4 py-2 rounded-lg border ${isDarkMode ? 'bg-gray-700 border-gray-600 text-white' : 'bg-white border-gray-300'}`}
              />
            </div>
            <div>
              <label className={`block font-medium mb-2 ${isDarkMode ? 'text-gray-300' : 'text-gray-700'}`}>Image URL (optional - if provided, will be used instead of emoji)</label>
              <input
                type="text"
                value={formData.image_url || ''}
                onChange={(e) => setFormData({ ...formData, image_url: e.target.value })}
                className={`w-full px-4 py-2 rounded-lg border ${isDarkMode ? 'bg-gray-700 border-gray-600 text-white' : 'bg-white border-gray-300'}`}
                placeholder="https://example.com/image.png"
              />
              {formData.image_url && (
                <div className="mt-2">
                  <img src={formData.image_url} alt="Preview" className="h-16 w-16 object-contain border rounded" />
                </div>
              )}
            </div>
            <div>
              <label className={`block font-medium mb-2 ${isDarkMode ? 'text-gray-300' : 'text-gray-700'}`}>Merchant</label>
              <select
                value={formData.merchant_id || ''}
                onChange={(e) => setFormData({ ...formData, merchant_id: e.target.value })}
                className={`w-full px-4 py-2 rounded-lg border ${isDarkMode ? 'bg-gray-700 border-gray-600 text-white' : 'bg-white border-gray-300'}`}
              >
                <option value="">Select Merchant</option>
                {merchants.map(m => (
                  <option key={m.id} value={m.id}>{m.name}</option>
                ))}
              </select>
            </div>
            {/* New Game Fields for Items */}
            <div className={`mt-4 p-3 rounded-lg ${isDarkMode ? 'bg-gray-900 border-gray-700' : 'bg-amber-50 border-amber-200'} border`}>
              <h4 className={`font-bold mb-2 text-sm ${isDarkMode ? 'text-amber-300' : 'text-amber-800'}`}>🏷️ Game Properties</h4>
              <div className="space-y-2">
                <div>
                  <label className={`block text-xs mb-1 ${isDarkMode ? 'text-gray-300' : 'text-gray-700'}`}>Description</label>
                  <textarea
                    value={formData.description || ''}
                    onChange={(e) => setFormData({ ...formData, description: e.target.value })}
                    rows="2"
                    className={`w-full px-2 py-1 rounded border text-sm ${isDarkMode ? 'bg-gray-700 border-gray-600 text-white' : 'bg-white border-gray-300'}`}
                    placeholder="A beautiful handwoven djellaba..."
                  />
                </div>
                <div className="grid grid-cols-2 gap-2">
                  <div>
                    <label className={`block text-xs mb-1 ${isDarkMode ? 'text-gray-300' : 'text-gray-700'}`}>Stock Quantity (-1 = unlimited)</label>
                    <input
                      type="number"
                      value={formData.stock_quantity != null ? formData.stock_quantity : -1}
                      onChange={(e) => setFormData({ ...formData, stock_quantity: parseInt(e.target.value) })}
                      min="-1"
                      className={`w-full px-2 py-1 rounded border text-sm ${isDarkMode ? 'bg-gray-700 border-gray-600 text-white' : 'bg-white border-gray-300'}`}
                    />
                  </div>
                  <div>
                    <label className={`block text-xs mb-1 ${isDarkMode ? 'text-gray-300' : 'text-gray-700'}`}>Season</label>
                    <select
                      value={formData.season || ''}
                      onChange={(e) => setFormData({ ...formData, season: e.target.value })}
                      className={`w-full px-2 py-1 rounded border text-sm ${isDarkMode ? 'bg-gray-700 border-gray-600 text-white' : 'bg-white border-gray-300'}`}
                    >
                      <option value="">Any</option>
                      <option value="summer">Summer</option>
                      <option value="winter">Winter</option>
                      <option value="spring">Spring</option>
                      <option value="all">All Seasons</option>
                    </select>
                  </div>
                </div>
                <div className="grid grid-cols-2 gap-2">
                  <div>
                    <label className={`block text-xs mb-1 ${isDarkMode ? 'text-gray-300' : 'text-gray-700'}`}>Layer Type</label>
                    <select
                      value={formData.layer_type || ''}
                      onChange={(e) => setFormData({ ...formData, layer_type: e.target.value })}
                      className={`w-full px-2 py-1 rounded border text-sm ${isDarkMode ? 'bg-gray-700 border-gray-600 text-white' : 'bg-white border-gray-300'}`}
                    >
                      <option value="">Not set</option>
                      <option value="head">Head</option>
                      <option value="top">Top</option>
                      <option value="bottom">Bottom</option>
                      <option value="shoes">Shoes</option>
                      <option value="accessory">Accessory</option>
                      <option value="outerwear">Outerwear</option>
                    </select>
                  </div>
                  <div>
                    <label className={`block text-xs mb-1 ${isDarkMode ? 'text-gray-300' : 'text-gray-700'}`}>Layer Order</label>
                    <input
                      type="number"
                      value={formData.layer_order || 0}
                      onChange={(e) => setFormData({ ...formData, layer_order: parseInt(e.target.value) })}
                      min="0"
                      className={`w-full px-2 py-1 rounded border text-sm ${isDarkMode ? 'bg-gray-700 border-gray-600 text-white' : 'bg-white border-gray-300'}`}
                    />
                  </div>
                </div>
                <div className="flex gap-4">
                  <label className="flex items-center gap-1.5 text-xs">
                    <input
                      type="checkbox"
                      checked={formData.is_rare || false}
                      onChange={(e) => setFormData({ ...formData, is_rare: e.target.checked })}
                      className="w-4 h-4"
                    />
                    <span className={isDarkMode ? 'text-gray-300' : 'text-gray-700'}>Rare Item</span>
                  </label>
                  <label className="flex items-center gap-1.5 text-xs">
                    <input
                      type="checkbox"
                      checked={formData.is_traditional || false}
                      onChange={(e) => setFormData({ ...formData, is_traditional: e.target.checked })}
                      className="w-4 h-4"
                    />
                    <span className={isDarkMode ? 'text-gray-300' : 'text-gray-700'}>Traditional</span>
                  </label>
                </div>

                {/* Sizes Available */}
                <div className="mt-3">
                  <label className={`block font-medium mb-1.5 text-xs ${isDarkMode ? 'text-gray-300' : 'text-gray-700'}`}>Sizes Available</label>
                  <div className="flex flex-wrap gap-2">
                    {['XS', 'S', 'M', 'L', 'XL', 'XXL'].map(size => (
                      <label key={size} className="flex items-center gap-1 text-xs">
                        <input
                          type="checkbox"
                          checked={(formData.sizes_available || []).includes(size)}
                          onChange={(e) => {
                            const sizes = formData.sizes_available || [];
                            setFormData({
                              ...formData,
                              sizes_available: e.target.checked
                                ? [...sizes, size]
                                : sizes.filter(s => s !== size)
                            });
                          }}
                          className="w-3.5 h-3.5"
                        />
                        <span className={isDarkMode ? 'text-gray-300' : 'text-gray-700'}>{size}</span>
                      </label>
                    ))}
                  </div>
                </div>

                {/* Colors Available */}
                <div className="mt-3">
                  <label className={`block font-medium mb-1.5 text-xs ${isDarkMode ? 'text-gray-300' : 'text-gray-700'}`}>Colors Available</label>
                  <div className="flex flex-wrap gap-1.5 mb-2">
                    {(formData.colors_available || []).map(color => (
                      <span key={color} className={`inline-flex items-center gap-1 px-2 py-1 rounded-full text-[10px] font-medium ${isDarkMode ? 'bg-gray-600 text-gray-200' : 'bg-gray-100 text-gray-700'}`}>
                        <span className="w-3 h-3 rounded-full border inline-block" style={{ backgroundColor: color.toLowerCase() }} />
                        {color}
                        <button
                          type="button"
                          onClick={() => setFormData({ ...formData, colors_available: (formData.colors_available || []).filter(c => c !== color) })}
                          className="ml-0.5 text-gray-400 hover:text-red-500"
                        >×</button>
                      </span>
                    ))}
                  </div>
                  <div className="flex gap-2">
                    <input
                      type="text"
                      placeholder="Type color and press Enter"
                      className={`flex-1 px-3 py-1.5 rounded-lg border text-xs ${isDarkMode ? 'bg-gray-700 border-gray-600 text-white' : 'bg-white border-gray-300'}`}
                      onKeyDown={(e) => {
                        if (e.key === 'Enter' || e.key === ',') {
                          e.preventDefault();
                          const val = e.target.value.trim().toLowerCase();
                          if (val && !(formData.colors_available || []).includes(val)) {
                            setFormData({ ...formData, colors_available: [...(formData.colors_available || []), val] });
                          }
                          e.target.value = '';
                        }
                      }}
                    />
                  </div>
                  <p className={`text-[10px] mt-1 ${isDarkMode ? 'text-gray-500' : 'text-gray-400'}`}>
                    Common: red, blue, green, yellow, white, black, brown, orange, pink, purple, gray, beige
                  </p>
                </div>
              </div>
            </div>
          </>
        );

      case 'missions':
        return (
          <>
            <div>
              <label className={`block font-medium mb-2 ${isDarkMode ? 'text-gray-300' : 'text-gray-700'}`}>Icon (Emoji)</label>
              <input
                type="text"
                value={formData.icon || ''}
                onChange={(e) => setFormData({ ...formData, icon: e.target.value })}
                className={`w-full px-4 py-2 rounded-lg border ${isDarkMode ? 'bg-gray-700 border-gray-600 text-white' : 'bg-white border-gray-300'}`}
                placeholder="🎯"
              />
            </div>
            <div>
              <label className={`block font-medium mb-2 ${isDarkMode ? 'text-gray-300' : 'text-gray-700'}`}>Name (English)</label>
              <input
                type="text"
                value={formData.name_english || ''}
                onChange={(e) => setFormData({ ...formData, name_english: e.target.value })}
                className={`w-full px-4 py-2 rounded-lg border ${isDarkMode ? 'bg-gray-700 border-gray-600 text-white' : 'bg-white border-gray-300'}`}
              />
            </div>
            <div>
              <label className={`block font-medium mb-2 ${isDarkMode ? 'text-gray-300' : 'text-gray-700'}`}>Name (Darija)</label>
              <input
                type="text"
                value={formData.name_darija || ''}
                onChange={(e) => setFormData({ ...formData, name_darija: e.target.value })}
                className={`w-full px-4 py-2 rounded-lg border ${isDarkMode ? 'bg-gray-700 border-gray-600 text-white' : 'bg-white border-gray-300'}`}
              />
            </div>
            <div>
              <label className={`block font-medium mb-2 ${isDarkMode ? 'text-gray-300' : 'text-gray-700'}`}>Description</label>
              <textarea
                value={formData.description || ''}
                onChange={(e) => setFormData({ ...formData, description: e.target.value })}
                rows="3"
                className={`w-full px-4 py-2 rounded-lg border ${isDarkMode ? 'bg-gray-700 border-gray-600 text-white' : 'bg-white border-gray-300'}`}
              />
            </div>
            <div>
              <label className={`block font-medium mb-2 ${isDarkMode ? 'text-gray-300' : 'text-gray-700'}`}>Occasion</label>
              <input
                type="text"
                value={formData.occasion || ''}
                onChange={(e) => setFormData({ ...formData, occasion: e.target.value })}
                className={`w-full px-4 py-2 rounded-lg border ${isDarkMode ? 'bg-gray-700 border-gray-600 text-white' : 'bg-white border-gray-300'}`}
                placeholder="e.g., Casual, Wedding, Sport"
              />
            </div>
            <div>
              <label className={`block font-medium mb-2 ${isDarkMode ? 'text-gray-300' : 'text-gray-700'}`}>Difficulty</label>
              <select
                value={formData.difficulty || 'easy'}
                onChange={(e) => setFormData({ ...formData, difficulty: e.target.value })}
                className={`w-full px-4 py-2 rounded-lg border ${isDarkMode ? 'bg-gray-700 border-gray-600 text-white' : 'bg-white border-gray-300'}`}
              >
                <option value="easy">Easy</option>
                <option value="medium">Medium</option>
                <option value="hard">Hard</option>
              </select>
            </div>
            <div>
              <label className={`block font-medium mb-2 ${isDarkMode ? 'text-gray-300' : 'text-gray-700'}`}>Reward Coins</label>
              <input
                type="number"
                value={formData.reward_coins || 0}
                onChange={(e) => setFormData({ ...formData, reward_coins: parseInt(e.target.value) })}
                className={`w-full px-4 py-2 rounded-lg border ${isDarkMode ? 'bg-gray-700 border-gray-600 text-white' : 'bg-white border-gray-300'}`}
              />
            </div>
            <div>
              <label className={`block font-medium mb-2 ${isDarkMode ? 'text-gray-300' : 'text-gray-700'}`}>Image URL (Optional)</label>
              <input
                type="text"
                value={formData.image_url || ''}
                onChange={(e) => setFormData({ ...formData, image_url: e.target.value })}
                className={`w-full px-4 py-2 rounded-lg border ${isDarkMode ? 'bg-gray-700 border-gray-600 text-white' : 'bg-white border-gray-300'}`}
                placeholder="https://example.com/outfit.jpg"
              />
              <p className={`text-xs mt-1 ${isDarkMode ? 'text-gray-400' : 'text-gray-500'}`}>
                Small image (will display as 48x48px thumbnail)
              </p>
            </div>
            {/* New Game Fields for Missions */}
            <div className={`mt-4 p-3 rounded-lg ${isDarkMode ? 'bg-gray-900 border-gray-700' : 'bg-purple-50 border-purple-200'} border`}>
              <h4 className={`font-bold mb-2 text-sm ${isDarkMode ? 'text-purple-300' : 'text-purple-800'}`}>🎮 Game Mechanics</h4>
              <div className="space-y-2">
                <div>
                  <label className={`block text-xs mb-1 ${isDarkMode ? 'text-gray-300' : 'text-gray-700'}`}>Story Text (cinematic intro)</label>
                  <textarea
                    value={formData.story_text || ''}
                    onChange={(e) => setFormData({ ...formData, story_text: e.target.value })}
                    rows="3"
                    className={`w-full px-2 py-1 rounded border text-sm ${isDarkMode ? 'bg-gray-700 border-gray-600 text-white' : 'bg-white border-gray-300'}`}
                    placeholder="Your cousin Youssef's wedding is TOMORROW. You need a djellaba, babouche, and tarboush..."
                  />
                </div>
                <div className="grid grid-cols-2 gap-2">
                  <div>
                    <label className={`block text-xs mb-1 ${isDarkMode ? 'text-gray-300' : 'text-gray-700'}`}>Time Limit (seconds, 0=no limit)</label>
                    <input
                      type="number"
                      value={formData.time_limit_seconds || 0}
                      onChange={(e) => setFormData({ ...formData, time_limit_seconds: parseInt(e.target.value) })}
                      min="0"
                      className={`w-full px-2 py-1 rounded border text-sm ${isDarkMode ? 'bg-gray-700 border-gray-600 text-white' : 'bg-white border-gray-300'}`}
                    />
                  </div>
                  <div>
                    <label className={`block text-xs mb-1 ${isDarkMode ? 'text-gray-300' : 'text-gray-700'}`}>Budget Limit (tokens, 0=no limit)</label>
                    <input
                      type="number"
                      value={formData.budget_limit || 0}
                      onChange={(e) => setFormData({ ...formData, budget_limit: parseInt(e.target.value) })}
                      min="0"
                      className={`w-full px-2 py-1 rounded border text-sm ${isDarkMode ? 'bg-gray-700 border-gray-600 text-white' : 'bg-white border-gray-300'}`}
                    />
                  </div>
                </div>
                <div>
                  <label className={`block text-xs mb-1 ${isDarkMode ? 'text-gray-300' : 'text-gray-700'}`}>Min Darija Phrases for Star</label>
                  <input
                    type="number"
                    value={formData.star_criteria?.darija_phrases_min || 3}
                    onChange={(e) => setFormData({ ...formData, star_criteria: { ...(formData.star_criteria || {}), darija_phrases_min: parseInt(e.target.value) } })}
                    min="0"
                    className={`w-full px-2 py-1 rounded border text-sm ${isDarkMode ? 'bg-gray-700 border-gray-600 text-white' : 'bg-white border-gray-300'}`}
                  />
                </div>
                <div className="flex items-center gap-2">
                  <input
                    type="checkbox"
                    checked={formData.is_active !== false}
                    onChange={(e) => setFormData({ ...formData, is_active: e.target.checked })}
                    className="w-4 h-4"
                  />
                  <label className={`text-xs ${isDarkMode ? 'text-gray-300' : 'text-gray-700'}`}>Active (visible to players)</label>
                </div>
              </div>
            </div>
            {/* Required Items Editor */}
            <div className={`mt-4 p-3 rounded-lg ${isDarkMode ? 'bg-gray-900 border-gray-700' : 'bg-teal-50 border-teal-200'} border`}>
              <h4 className={`font-bold mb-2 text-sm ${isDarkMode ? 'text-teal-300' : 'text-teal-800'}`}>🧥 Required Items</h4>
              <div className="space-y-1 mb-2">
                {(formData.required_items || []).map((ri, idx) => {
                  const itemObj = (allItems || []).find(i => i.id === (typeof ri === 'object' ? (ri.item_id || ri.id) : ri));
                  return (
                    <div key={idx} className={`flex items-center gap-2 p-1.5 rounded ${isDarkMode ? 'bg-gray-800' : 'bg-white'}`}>
                      <span className="text-sm flex-1">{itemObj ? `${itemObj.icon || '👕'} ${itemObj.name_english || itemObj.name || 'Item'}` : (typeof ri === 'object' ? ri.item_id : ri)}</span>
                      <button
                        onClick={() => {
                          const updated = [...(formData.required_items || [])];
                          updated.splice(idx, 1);
                          setFormData({ ...formData, required_items: updated });
                        }}
                        className="text-red-500 hover:text-red-700 text-xs font-bold px-1"
                      >✕</button>
                    </div>
                  );
                })}
              </div>
              {(allItems || []).length > 0 ? (
                <select
                  value=""
                  onChange={(e) => {
                    if (!e.target.value) return;
                    const current = formData.required_items || [];
                    const already = current.some(ri => {
                      const rid = typeof ri === 'object' ? (ri.item_id || ri.id) : ri;
                      return rid === e.target.value;
                    });
                    if (!already) {
                      setFormData({ ...formData, required_items: [...current, { item_id: e.target.value }] });
                    }
                    e.target.value = '';
                  }}
                  className={`w-full px-2 py-1 rounded border text-sm ${isDarkMode ? 'bg-gray-700 border-gray-600 text-white' : 'bg-white border-gray-300'}`}
                >
                  <option value="">+ Add required item...</option>
                  {(allItems || []).map(it => (
                    <option key={it.id} value={it.id}>{it.icon || '👕'} {it.name_english || it.name || 'Item'} ({it.category || 'no category'})</option>
                  ))}
                </select>
              ) : (
                <p className={`text-xs ${isDarkMode ? 'text-gray-400' : 'text-gray-500'}`}>Load items section first to pick required items</p>
              )}
            </div>
          </>
        );

      case 'areas':
        return (
          <>
            <div>
              <label className={`block font-medium mb-2 ${isDarkMode ? 'text-gray-300' : 'text-gray-700'}`}>Icon (Emoji)</label>
              <input
                type="text"
                value={formData.icon || ''}
                onChange={(e) => setFormData({ ...formData, icon: e.target.value })}
                className={`w-full px-4 py-2 rounded-lg border ${isDarkMode ? 'bg-gray-700 border-gray-600 text-white' : 'bg-white border-gray-300'}`}
                placeholder="🏪"
              />
            </div>
            <div>
              <label className={`block font-medium mb-2 ${isDarkMode ? 'text-gray-300' : 'text-gray-700'}`}>Name</label>
              <input
                type="text"
                value={formData.name || ''}
                onChange={(e) => setFormData({ ...formData, name: e.target.value })}
                className={`w-full px-4 py-2 rounded-lg border ${isDarkMode ? 'bg-gray-700 border-gray-600 text-white' : 'bg-white border-gray-300'}`}
                placeholder="Main Alley"
              />
            </div>
            <div>
              <label className={`block font-medium mb-2 ${isDarkMode ? 'text-gray-300' : 'text-gray-700'}`}>Name (Darija)</label>
              <input
                type="text"
                value={formData.name_darija || ''}
                onChange={(e) => setFormData({ ...formData, name_darija: e.target.value })}
                className={`w-full px-4 py-2 rounded-lg border ${isDarkMode ? 'bg-gray-700 border-gray-600 text-white' : 'bg-white border-gray-300'}`}
                placeholder="Zanqa Kbira"
              />
            </div>
            <div>
              <label className={`block font-medium mb-2 ${isDarkMode ? 'text-gray-300' : 'text-gray-700'}`}>Description</label>
              <textarea
                value={formData.description || ''}
                onChange={(e) => setFormData({ ...formData, description: e.target.value })}
                rows="2"
                className={`w-full px-4 py-2 rounded-lg border ${isDarkMode ? 'bg-gray-700 border-gray-600 text-white' : 'bg-white border-gray-300'}`}
                placeholder="The bustling main street of the souk"
              />
            </div>
            <div className="grid grid-cols-2 gap-3">
              <div>
                <label className={`block font-medium mb-2 ${isDarkMode ? 'text-gray-300' : 'text-gray-700'}`}>Unlock Requirement (missions)</label>
                <input
                  type="number"
                  value={formData.unlock_requirement || 0}
                  onChange={(e) => setFormData({ ...formData, unlock_requirement: parseInt(e.target.value) })}
                  min="0"
                  className={`w-full px-4 py-2 rounded-lg border ${isDarkMode ? 'bg-gray-700 border-gray-600 text-white' : 'bg-white border-gray-300'}`}
                />
                <p className={`text-xs mt-1 ${isDarkMode ? 'text-gray-400' : 'text-gray-500'}`}>0 = always unlocked</p>
              </div>
              <div>
                <label className={`block font-medium mb-2 ${isDarkMode ? 'text-gray-300' : 'text-gray-700'}`}>Display Order</label>
                <input
                  type="number"
                  value={formData.order || 0}
                  onChange={(e) => setFormData({ ...formData, order: parseInt(e.target.value) })}
                  min="0"
                  className={`w-full px-4 py-2 rounded-lg border ${isDarkMode ? 'bg-gray-700 border-gray-600 text-white' : 'bg-white border-gray-300'}`}
                />
              </div>
            </div>
            <div className="flex items-center">
              <input
                type="checkbox"
                checked={formData.is_active !== false}
                onChange={(e) => setFormData({ ...formData, is_active: e.target.checked })}
                className="w-5 h-5 mr-2"
              />
              <label className={`font-medium ${isDarkMode ? 'text-gray-300' : 'text-gray-700'}`}>Active</label>
            </div>
          </>
        );

      default:
        return <p>Unknown type</p>;
    }
  };

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center p-4" style={{ backgroundColor: 'rgba(0, 0, 0, 0.75)' }}>
      <div className={`max-w-2xl w-full rounded-xl shadow-2xl p-6 max-h-[90vh] overflow-y-auto ${isDarkMode ? 'bg-gray-800 border-gray-700' : 'bg-white border-gray-200'} border`}>
        <h3 className={`text-2xl font-bold mb-6 ${isDarkMode ? 'text-white' : 'text-gray-800'}`}>
          Edit {type.slice(0, -1).charAt(0).toUpperCase() + type.slice(1, -1)}
        </h3>
        
        <div className="space-y-4">
          {renderFields()}
        </div>

        <div className="flex gap-3 mt-6">
          <button
            onClick={onClose}
            className={`flex-1 py-3 rounded-lg font-medium ${isDarkMode ? 'bg-gray-700 hover:bg-gray-600 text-gray-300' : 'bg-gray-200 hover:bg-gray-300 text-gray-700'}`}
          >
            Cancel
          </button>
          <button
            onClick={() => onSave(formData)}
            className="flex-1 py-3 bg-blue-600 hover:bg-blue-700 text-white rounded-lg font-medium"
          >
            Save Changes
          </button>
        </div>
      </div>
    </div>
  );
};

// Add Modal Component
export const AddModal = ({ type, merchants, categories, areas, allItems, onSave, onClose, isDarkMode }) => {
  const getDefaultData = () => {
    switch (type) {
      case 'merchants':
        return { avatar: '👤', name: '', specialty: '', greeting_english: '', greeting_darija: '', is_active: true };
      case 'categories':
        return { id: '', name: '', icon: '📁', order: 0 };
      case 'items':
        return { icon: '👕', name_english: '', name_darija: '', category: 'tops', gender: 'unisex', base_price_tokens: 50, image_url: '', merchant_id: '', stock_quantity: -1, is_rare: false, is_traditional: false, colors_available: [], sizes_available: [] };
      case 'missions':
        return { icon: '🎯', name_english: '', name_darija: '', description: '', occasion: '', difficulty: 'easy', reward_coins: 50, is_active: true, time_limit_seconds: 0, budget_limit: 0, story_text: '', required_items: [] };
      case 'areas':
        return { icon: '🏪', name: '', name_darija: '', description: '', unlock_requirement: 0, order: 0, is_active: true };
      default:
        return {};
    }
  };

  const [formData, setFormData] = useState(getDefaultData());

  const renderFields = () => {
    switch (type) {
      case 'merchants':
        return (
          <>
            <div>
              <label className={`block font-medium mb-2 ${isDarkMode ? 'text-gray-300' : 'text-gray-700'}`}>Avatar (Emoji)</label>
              <input
                type="text"
                value={formData.avatar}
                onChange={(e) => setFormData({ ...formData, avatar: e.target.value })}
                className={`w-full px-4 py-2 rounded-lg border ${isDarkMode ? 'bg-gray-700 border-gray-600 text-white' : 'bg-white border-gray-300'}`}
                placeholder="👤"
              />
            </div>
            <div>
              <label className={`block font-medium mb-2 ${isDarkMode ? 'text-gray-300' : 'text-gray-700'}`}>Name</label>
              <input
                type="text"
                value={formData.name}
                onChange={(e) => setFormData({ ...formData, name: e.target.value })}
                className={`w-full px-4 py-2 rounded-lg border ${isDarkMode ? 'bg-gray-700 border-gray-600 text-white' : 'bg-white border-gray-300'}`}
              />
            </div>
            <div>
              <label className={`block font-medium mb-2 ${isDarkMode ? 'text-gray-300' : 'text-gray-700'}`}>Specialty</label>
              <input
                type="text"
                value={formData.specialty}
                onChange={(e) => setFormData({ ...formData, specialty: e.target.value })}
                className={`w-full px-4 py-2 rounded-lg border ${isDarkMode ? 'bg-gray-700 border-gray-600 text-white' : 'bg-white border-gray-300'}`}
              />
            </div>
            <div>
              <label className={`block font-medium mb-2 ${isDarkMode ? 'text-gray-300' : 'text-gray-700'}`}>Greeting (English)</label>
              <textarea
                value={formData.greeting_english}
                onChange={(e) => setFormData({ ...formData, greeting_english: e.target.value })}
                rows="2"
                className={`w-full px-4 py-2 rounded-lg border ${isDarkMode ? 'bg-gray-700 border-gray-600 text-white' : 'bg-white border-gray-300'}`}
              />
            </div>
            <div>
              <label className={`block font-medium mb-2 ${isDarkMode ? 'text-gray-300' : 'text-gray-700'}`}>Greeting (Darija)</label>
              <textarea
                value={formData.greeting_darija}
                onChange={(e) => setFormData({ ...formData, greeting_darija: e.target.value })}
                rows="2"
                className={`w-full px-4 py-2 rounded-lg border ${isDarkMode ? 'bg-gray-700 border-gray-600 text-white' : 'bg-white border-gray-300'}`}
              />
            </div>
            <div>
              <label className={`block font-medium mb-2 ${isDarkMode ? 'text-gray-300' : 'text-gray-700'}`}>Image URL (avatar photo)</label>
              <input
                type="text"
                value={formData.image_url || ''}
                onChange={(e) => setFormData({ ...formData, image_url: e.target.value })}
                className={`w-full px-4 py-2 rounded-lg border ${isDarkMode ? 'bg-gray-700 border-gray-600 text-white' : 'bg-white border-gray-300'}`}
                placeholder="https://dl.dropboxusercontent.com/..."
              />
            </div>
            <div>
              <label className={`block font-medium mb-2 ${isDarkMode ? 'text-gray-300' : 'text-gray-700'}`}>Personality</label>
              <select
                value={formData.personality || ''}
                onChange={(e) => setFormData({ ...formData, personality: e.target.value })}
                className={`w-full px-4 py-2 rounded-lg border ${isDarkMode ? 'bg-gray-700 border-gray-600 text-white' : 'bg-white border-gray-300'}`}
              >
                <option value="">Not set</option>
                <option value="friendly">Friendly</option>
                <option value="tough">Tough</option>
                <option value="tricky">Tricky</option>
                <option value="generous">Generous</option>
              </select>
            </div>
            <div>
              <label className={`block font-medium mb-2 ${isDarkMode ? 'text-gray-300' : 'text-gray-700'}`}>Callout Text</label>
              <input
                type="text"
                value={formData.callout_text || ''}
                onChange={(e) => setFormData({ ...formData, callout_text: e.target.value })}
                className={`w-full px-4 py-2 rounded-lg border ${isDarkMode ? 'bg-gray-700 border-gray-600 text-white' : 'bg-white border-gray-300'}`}
                placeholder="Aji aji! Best djellabas here!"
              />
            </div>
          </>
        );

      case 'categories':
        return (
          <>
            <div>
              <label className={`block font-medium mb-2 ${isDarkMode ? 'text-gray-300' : 'text-gray-700'}`}>Category ID</label>
              <input
                type="text"
                value={formData.id || ''}
                disabled
                className={`w-full px-4 py-2 rounded-lg border bg-gray-200 text-gray-600 ${isDarkMode ? 'bg-gray-800 border-gray-600' : ''}`}
              />
              <p className={`text-xs mt-1 ${isDarkMode ? 'text-gray-400' : 'text-gray-500'}`}>ID cannot be changed</p>
            </div>
            <div>
              <label className={`block font-medium mb-2 ${isDarkMode ? 'text-gray-300' : 'text-gray-700'}`}>Category Name</label>
              <input
                type="text"
                value={formData.name || ''}
                onChange={(e) => setFormData({ ...formData, name: e.target.value })}
                className={`w-full px-4 py-2 rounded-lg border ${isDarkMode ? 'bg-gray-700 border-gray-600 text-white' : 'bg-white border-gray-300'}`}
              />
            </div>
            <div>
              <label className={`block font-medium mb-2 ${isDarkMode ? 'text-gray-300' : 'text-gray-700'}`}>Icon (Emoji)</label>
              <input
                type="text"
                value={formData.icon || '📁'}
                onChange={(e) => setFormData({ ...formData, icon: e.target.value })}
                className={`w-full px-4 py-2 rounded-lg border ${isDarkMode ? 'bg-gray-700 border-gray-600 text-white' : 'bg-white border-gray-300'}`}
              />
            </div>
            <div>
              <label className={`block font-medium mb-2 ${isDarkMode ? 'text-gray-300' : 'text-gray-700'}`}>Display Order</label>
              <input
                type="number"
                value={formData.order || 0}
                onChange={(e) => setFormData({ ...formData, order: parseInt(e.target.value) })}
                className={`w-full px-4 py-2 rounded-lg border ${isDarkMode ? 'bg-gray-700 border-gray-600 text-white' : 'bg-white border-gray-300'}`}
              />
            </div>
          </>
        );

      case 'items':
        return (
          <>
            <div>
              <label className={`block font-medium mb-2 ${isDarkMode ? 'text-gray-300' : 'text-gray-700'}`}>Icon (Emoji)</label>
              <input
                type="text"
                value={formData.icon}
                onChange={(e) => setFormData({ ...formData, icon: e.target.value })}
                className={`w-full px-4 py-2 rounded-lg border ${isDarkMode ? 'bg-gray-700 border-gray-600 text-white' : 'bg-white border-gray-300'}`}
                placeholder="👕"
              />
            </div>
            <div>
              <label className={`block font-medium mb-2 ${isDarkMode ? 'text-gray-300' : 'text-gray-700'}`}>Name (English)</label>
              <input
                type="text"
                value={formData.name_english}
                onChange={(e) => setFormData({ ...formData, name_english: e.target.value })}
                className={`w-full px-4 py-2 rounded-lg border ${isDarkMode ? 'bg-gray-700 border-gray-600 text-white' : 'bg-white border-gray-300'}`}
              />
            </div>
            <div>
              <label className={`block font-medium mb-2 ${isDarkMode ? 'text-gray-300' : 'text-gray-700'}`}>Name (Darija)</label>
              <input
                type="text"
                value={formData.name_darija}
                onChange={(e) => setFormData({ ...formData, name_darija: e.target.value })}
                className={`w-full px-4 py-2 rounded-lg border ${isDarkMode ? 'bg-gray-700 border-gray-600 text-white' : 'bg-white border-gray-300'}`}
              />
            </div>
            <div>
              <label className={`block font-medium mb-2 ${isDarkMode ? 'text-gray-300' : 'text-gray-700'}`}>Name (Arabic Script)</label>
              <input
                type="text"
                value={formData.name_arabic || ''}
                onChange={(e) => setFormData({ ...formData, name_arabic: e.target.value })}
                className={`w-full px-4 py-2 rounded-lg border ${isDarkMode ? 'bg-gray-700 border-gray-600 text-white' : 'bg-white border-gray-300'}`}
                placeholder="e.g., قميجة"
                dir="rtl"
              />
            </div>
            <div>
              <label className={`block font-medium mb-2 ${isDarkMode ? 'text-gray-300' : 'text-gray-700'}`}>Pronunciation (optional)</label>
              <input
                type="text"
                value={formData.pronunciation || ''}
                onChange={(e) => setFormData({ ...formData, pronunciation: e.target.value })}
                className={`w-full px-4 py-2 rounded-lg border ${isDarkMode ? 'bg-gray-700 border-gray-600 text-white' : 'bg-white border-gray-300'}`}
                placeholder="e.g., qmija"
              />
            </div>
            <div>
              <label className={`block font-medium mb-2 ${isDarkMode ? 'text-gray-300' : 'text-gray-700'}`}>Category</label>
              <select
                value={formData.category}
                onChange={(e) => setFormData({ ...formData, category: e.target.value })}
                className={`w-full px-4 py-2 rounded-lg border ${isDarkMode ? 'bg-gray-700 border-gray-600 text-white' : 'bg-white border-gray-300'}`}
              >
                {(categories && categories.length > 0) ? (
                  categories.map(cat => (
                    <option key={cat.id} value={cat.id}>{cat.name}</option>
                  ))
                ) : (
                  <>
                    <option value="tops">Tops</option>
                    <option value="bottoms">Bottoms</option>
                    <option value="shoes">Shoes</option>
                    <option value="accessories">Accessories</option>
                    <option value="outerwear">Outerwear</option>
                  </>
                )}
              </select>
            </div>
            <div>
              <label className={`block font-medium mb-2 ${isDarkMode ? 'text-gray-300' : 'text-gray-700'}`}>Gender</label>
              <select
                value={formData.gender}
                onChange={(e) => setFormData({ ...formData, gender: e.target.value })}
                className={`w-full px-4 py-2 rounded-lg border ${isDarkMode ? 'bg-gray-700 border-gray-600 text-white' : 'bg-white border-gray-300'}`}
              >
                <option value="male">Male</option>
                <option value="female">Female</option>
                <option value="unisex">Unisex</option>
              </select>
            </div>
            <div>
              <label className={`block font-medium mb-2 ${isDarkMode ? 'text-gray-300' : 'text-gray-700'}`}>Base Price (Tokens)</label>
              <input
                type="number"
                value={formData.base_price_tokens || formData.base_price_dh}
                onChange={(e) => setFormData({ ...formData, base_price_tokens: parseInt(e.target.value) })}
                className={`w-full px-4 py-2 rounded-lg border ${isDarkMode ? 'bg-gray-700 border-gray-600 text-white' : 'bg-white border-gray-300'}`}
              />
            </div>
            <div>
              <label className={`block font-medium mb-2 ${isDarkMode ? 'text-gray-300' : 'text-gray-700'}`}>Image URL</label>
              <input
                type="text"
                value={formData.image_url}
                onChange={(e) => setFormData({ ...formData, image_url: e.target.value })}
                className={`w-full px-4 py-2 rounded-lg border ${isDarkMode ? 'bg-gray-700 border-gray-600 text-white' : 'bg-white border-gray-300'}`}
                placeholder="https://..."
              />
            </div>
            <div>
              <label className={`block font-medium mb-2 ${isDarkMode ? 'text-gray-300' : 'text-gray-700'}`}>Merchant</label>
              <select
                value={formData.merchant_id}
                onChange={(e) => setFormData({ ...formData, merchant_id: e.target.value })}
                className={`w-full px-4 py-2 rounded-lg border ${isDarkMode ? 'bg-gray-700 border-gray-600 text-white' : 'bg-white border-gray-300'}`}
              >
                <option value="">Select Merchant</option>
                {merchants.map(m => (
                  <option key={m.id} value={m.id}>{m.name}</option>
                ))}
              </select>
            </div>
            {/* Game fields for new items */}
            <div className="grid grid-cols-2 gap-3">
              <div>
                <label className={`block font-medium mb-2 ${isDarkMode ? 'text-gray-300' : 'text-gray-700'}`}>Stock Qty (-1=unlimited)</label>
                <input
                  type="number"
                  value={formData.stock_quantity != null ? formData.stock_quantity : -1}
                  onChange={(e) => setFormData({ ...formData, stock_quantity: parseInt(e.target.value) })}
                  min="-1"
                  className={`w-full px-4 py-2 rounded-lg border ${isDarkMode ? 'bg-gray-700 border-gray-600 text-white' : 'bg-white border-gray-300'}`}
                />
              </div>
              <div>
                <label className={`block font-medium mb-2 ${isDarkMode ? 'text-gray-300' : 'text-gray-700'}`}>Layer Type</label>
                <select
                  value={formData.layer_type || ''}
                  onChange={(e) => setFormData({ ...formData, layer_type: e.target.value })}
                  className={`w-full px-4 py-2 rounded-lg border ${isDarkMode ? 'bg-gray-700 border-gray-600 text-white' : 'bg-white border-gray-300'}`}
                >
                  <option value="">Not set</option>
                  <option value="head">Head</option>
                  <option value="top">Top</option>
                  <option value="bottom">Bottom</option>
                  <option value="shoes">Shoes</option>
                  <option value="accessory">Accessory</option>
                  <option value="outerwear">Outerwear</option>
                </select>
              </div>
            </div>
            <div className="flex gap-4">
              <label className="flex items-center gap-1.5">
                <input type="checkbox" checked={formData.is_rare || false} onChange={(e) => setFormData({ ...formData, is_rare: e.target.checked })} className="w-4 h-4" />
                <span className={`text-sm ${isDarkMode ? 'text-gray-300' : 'text-gray-700'}`}>Rare</span>
              </label>
              <label className="flex items-center gap-1.5">
                <input type="checkbox" checked={formData.is_traditional || false} onChange={(e) => setFormData({ ...formData, is_traditional: e.target.checked })} className="w-4 h-4" />
                <span className={`text-sm ${isDarkMode ? 'text-gray-300' : 'text-gray-700'}`}>Traditional</span>
              </label>
            </div>

            {/* Sizes Available */}
            <div className="mt-3">
              <label className={`block font-medium mb-1.5 text-sm ${isDarkMode ? 'text-gray-300' : 'text-gray-700'}`}>Sizes Available</label>
              <div className="flex flex-wrap gap-2">
                {['XS', 'S', 'M', 'L', 'XL', 'XXL'].map(size => (
                  <label key={size} className="flex items-center gap-1 text-sm">
                    <input
                      type="checkbox"
                      checked={(formData.sizes_available || []).includes(size)}
                      onChange={(e) => {
                        const sizes = formData.sizes_available || [];
                        setFormData({
                          ...formData,
                          sizes_available: e.target.checked
                            ? [...sizes, size]
                            : sizes.filter(s => s !== size)
                        });
                      }}
                      className="w-4 h-4"
                    />
                    <span className={isDarkMode ? 'text-gray-300' : 'text-gray-700'}>{size}</span>
                  </label>
                ))}
              </div>
            </div>

            {/* Colors Available */}
            <div className="mt-3">
              <label className={`block font-medium mb-1.5 text-sm ${isDarkMode ? 'text-gray-300' : 'text-gray-700'}`}>Colors Available</label>
              <div className="flex flex-wrap gap-1.5 mb-2">
                {(formData.colors_available || []).map(color => (
                  <span key={color} className={`inline-flex items-center gap-1 px-2 py-1 rounded-full text-xs font-medium ${isDarkMode ? 'bg-gray-600 text-gray-200' : 'bg-gray-100 text-gray-700'}`}>
                    <span className="w-3 h-3 rounded-full border inline-block" style={{ backgroundColor: color.toLowerCase() }} />
                    {color}
                    <button
                      type="button"
                      onClick={() => setFormData({ ...formData, colors_available: (formData.colors_available || []).filter(c => c !== color) })}
                      className="ml-0.5 text-gray-400 hover:text-red-500"
                    >×</button>
                  </span>
                ))}
              </div>
              <div className="flex gap-2">
                <input
                  type="text"
                  placeholder="Type color and press Enter"
                  className={`flex-1 px-3 py-2 rounded-lg border text-sm ${isDarkMode ? 'bg-gray-700 border-gray-600 text-white' : 'bg-white border-gray-300'}`}
                  onKeyDown={(e) => {
                    if (e.key === 'Enter' || e.key === ',') {
                      e.preventDefault();
                      const val = e.target.value.trim().toLowerCase();
                      if (val && !(formData.colors_available || []).includes(val)) {
                        setFormData({ ...formData, colors_available: [...(formData.colors_available || []), val] });
                      }
                      e.target.value = '';
                    }
                  }}
                />
              </div>
              <p className={`text-[10px] mt-1 ${isDarkMode ? 'text-gray-500' : 'text-gray-400'}`}>
                Common: red, blue, green, yellow, white, black, brown, orange, pink, purple, gray, beige
              </p>
            </div>
          </>
        );

      case 'missions':
        return (
          <>
            <div>
              <label className={`block font-medium mb-2 ${isDarkMode ? 'text-gray-300' : 'text-gray-700'}`}>Icon (Emoji)</label>
              <input type="text" value={formData.icon} onChange={(e) => setFormData({ ...formData, icon: e.target.value })}
                className={`w-full px-4 py-2 rounded-lg border ${isDarkMode ? 'bg-gray-700 border-gray-600 text-white' : 'bg-white border-gray-300'}`} placeholder="🎯" />
            </div>
            <div>
              <label className={`block font-medium mb-2 ${isDarkMode ? 'text-gray-300' : 'text-gray-700'}`}>Name (English)</label>
              <input type="text" value={formData.name_english} onChange={(e) => setFormData({ ...formData, name_english: e.target.value })}
                className={`w-full px-4 py-2 rounded-lg border ${isDarkMode ? 'bg-gray-700 border-gray-600 text-white' : 'bg-white border-gray-300'}`} />
            </div>
            <div>
              <label className={`block font-medium mb-2 ${isDarkMode ? 'text-gray-300' : 'text-gray-700'}`}>Name (Darija)</label>
              <input type="text" value={formData.name_darija} onChange={(e) => setFormData({ ...formData, name_darija: e.target.value })}
                className={`w-full px-4 py-2 rounded-lg border ${isDarkMode ? 'bg-gray-700 border-gray-600 text-white' : 'bg-white border-gray-300'}`} />
            </div>
            <div>
              <label className={`block font-medium mb-2 ${isDarkMode ? 'text-gray-300' : 'text-gray-700'}`}>Description</label>
              <textarea value={formData.description} onChange={(e) => setFormData({ ...formData, description: e.target.value })} rows="2"
                className={`w-full px-4 py-2 rounded-lg border ${isDarkMode ? 'bg-gray-700 border-gray-600 text-white' : 'bg-white border-gray-300'}`} />
            </div>
            <div>
              <label className={`block font-medium mb-2 ${isDarkMode ? 'text-gray-300' : 'text-gray-700'}`}>Story Text (cinematic intro)</label>
              <textarea value={formData.story_text || ''} onChange={(e) => setFormData({ ...formData, story_text: e.target.value })} rows="3"
                className={`w-full px-4 py-2 rounded-lg border ${isDarkMode ? 'bg-gray-700 border-gray-600 text-white' : 'bg-white border-gray-300'}`}
                placeholder="Your cousin Youssef's wedding is TOMORROW..." />
            </div>
            <div className="grid grid-cols-3 gap-3">
              <div>
                <label className={`block font-medium mb-2 ${isDarkMode ? 'text-gray-300' : 'text-gray-700'}`}>Difficulty</label>
                <select value={formData.difficulty} onChange={(e) => setFormData({ ...formData, difficulty: e.target.value })}
                  className={`w-full px-4 py-2 rounded-lg border ${isDarkMode ? 'bg-gray-700 border-gray-600 text-white' : 'bg-white border-gray-300'}`}>
                  <option value="easy">Easy</option>
                  <option value="medium">Medium</option>
                  <option value="hard">Hard</option>
                </select>
              </div>
              <div>
                <label className={`block font-medium mb-2 ${isDarkMode ? 'text-gray-300' : 'text-gray-700'}`}>Time Limit (sec)</label>
                <input type="number" value={formData.time_limit_seconds || 0} onChange={(e) => setFormData({ ...formData, time_limit_seconds: parseInt(e.target.value) })}
                  min="0" className={`w-full px-4 py-2 rounded-lg border ${isDarkMode ? 'bg-gray-700 border-gray-600 text-white' : 'bg-white border-gray-300'}`} />
              </div>
              <div>
                <label className={`block font-medium mb-2 ${isDarkMode ? 'text-gray-300' : 'text-gray-700'}`}>Budget Limit</label>
                <input type="number" value={formData.budget_limit || 0} onChange={(e) => setFormData({ ...formData, budget_limit: parseInt(e.target.value) })}
                  min="0" className={`w-full px-4 py-2 rounded-lg border ${isDarkMode ? 'bg-gray-700 border-gray-600 text-white' : 'bg-white border-gray-300'}`} />
              </div>
            </div>
            <div>
              <label className={`block font-medium mb-2 ${isDarkMode ? 'text-gray-300' : 'text-gray-700'}`}>Reward Coins</label>
              <input type="number" value={formData.reward_coins} onChange={(e) => setFormData({ ...formData, reward_coins: parseInt(e.target.value) })}
                className={`w-full px-4 py-2 rounded-lg border ${isDarkMode ? 'bg-gray-700 border-gray-600 text-white' : 'bg-white border-gray-300'}`} />
            </div>
            <div>
              <label className={`block font-medium mb-2 ${isDarkMode ? 'text-gray-300' : 'text-gray-700'}`}>Occasion</label>
              <input type="text" value={formData.occasion || ''} onChange={(e) => setFormData({ ...formData, occasion: e.target.value })}
                className={`w-full px-4 py-2 rounded-lg border ${isDarkMode ? 'bg-gray-700 border-gray-600 text-white' : 'bg-white border-gray-300'}`} placeholder="Casual, Wedding, Sport..." />
            </div>
            {/* Required Items Picker */}
            <div className={`p-3 rounded-lg ${isDarkMode ? 'bg-gray-900 border-gray-700' : 'bg-teal-50 border-teal-200'} border`}>
              <h4 className={`font-bold mb-2 text-sm ${isDarkMode ? 'text-teal-300' : 'text-teal-800'}`}>Required Items</h4>
              <div className="space-y-1 mb-2">
                {(formData.required_items || []).map((ri, idx) => {
                  const itemObj = (allItems || []).find(i => i.id === (typeof ri === 'object' ? (ri.item_id || ri.id) : ri));
                  return (
                    <div key={idx} className={`flex items-center gap-2 p-1.5 rounded ${isDarkMode ? 'bg-gray-800' : 'bg-white'}`}>
                      <span className="text-sm flex-1">{itemObj ? `${itemObj.icon || ''} ${itemObj.name_english || 'Item'}` : (typeof ri === 'object' ? ri.item_id : ri)}</span>
                      <button onClick={() => { const u = [...(formData.required_items || [])]; u.splice(idx, 1); setFormData({ ...formData, required_items: u }); }}
                        className="text-red-500 hover:text-red-700 text-xs font-bold px-1">x</button>
                    </div>
                  );
                })}
              </div>
              {(allItems || []).length > 0 ? (
                <select value="" onChange={(e) => {
                  if (!e.target.value) return;
                  const cur = formData.required_items || [];
                  if (!cur.some(ri => (typeof ri === 'object' ? (ri.item_id || ri.id) : ri) === e.target.value)) {
                    setFormData({ ...formData, required_items: [...cur, { item_id: e.target.value }] });
                  }
                  e.target.value = '';
                }} className={`w-full px-2 py-1 rounded border text-sm ${isDarkMode ? 'bg-gray-700 border-gray-600 text-white' : 'bg-white border-gray-300'}`}>
                  <option value="">+ Add required item...</option>
                  {(allItems || []).map(it => (
                    <option key={it.id} value={it.id}>{it.icon || ''} {it.name_english || 'Item'} ({it.category || ''})</option>
                  ))}
                </select>
              ) : (
                <p className={`text-xs ${isDarkMode ? 'text-gray-400' : 'text-gray-500'}`}>Load Items section first to pick required items</p>
              )}
            </div>
          </>
        );

      case 'areas':
        return (
          <>
            <div>
              <label className={`block font-medium mb-2 ${isDarkMode ? 'text-gray-300' : 'text-gray-700'}`}>Icon (Emoji)</label>
              <input type="text" value={formData.icon} onChange={(e) => setFormData({ ...formData, icon: e.target.value })}
                className={`w-full px-4 py-2 rounded-lg border ${isDarkMode ? 'bg-gray-700 border-gray-600 text-white' : 'bg-white border-gray-300'}`} placeholder="🏪" />
            </div>
            <div>
              <label className={`block font-medium mb-2 ${isDarkMode ? 'text-gray-300' : 'text-gray-700'}`}>Name</label>
              <input type="text" value={formData.name} onChange={(e) => setFormData({ ...formData, name: e.target.value })}
                className={`w-full px-4 py-2 rounded-lg border ${isDarkMode ? 'bg-gray-700 border-gray-600 text-white' : 'bg-white border-gray-300'}`} placeholder="Main Alley" />
            </div>
            <div>
              <label className={`block font-medium mb-2 ${isDarkMode ? 'text-gray-300' : 'text-gray-700'}`}>Name (Darija)</label>
              <input type="text" value={formData.name_darija} onChange={(e) => setFormData({ ...formData, name_darija: e.target.value })}
                className={`w-full px-4 py-2 rounded-lg border ${isDarkMode ? 'bg-gray-700 border-gray-600 text-white' : 'bg-white border-gray-300'}`} placeholder="Zanqa Kbira" />
            </div>
            <div>
              <label className={`block font-medium mb-2 ${isDarkMode ? 'text-gray-300' : 'text-gray-700'}`}>Description</label>
              <textarea value={formData.description} onChange={(e) => setFormData({ ...formData, description: e.target.value })} rows="2"
                className={`w-full px-4 py-2 rounded-lg border ${isDarkMode ? 'bg-gray-700 border-gray-600 text-white' : 'bg-white border-gray-300'}`} placeholder="The bustling main street..." />
            </div>
            <div className="grid grid-cols-2 gap-3">
              <div>
                <label className={`block font-medium mb-2 ${isDarkMode ? 'text-gray-300' : 'text-gray-700'}`}>Unlock Req (missions)</label>
                <input type="number" value={formData.unlock_requirement || 0} onChange={(e) => setFormData({ ...formData, unlock_requirement: parseInt(e.target.value) })}
                  min="0" className={`w-full px-4 py-2 rounded-lg border ${isDarkMode ? 'bg-gray-700 border-gray-600 text-white' : 'bg-white border-gray-300'}`} />
              </div>
              <div>
                <label className={`block font-medium mb-2 ${isDarkMode ? 'text-gray-300' : 'text-gray-700'}`}>Display Order</label>
                <input type="number" value={formData.order || 0} onChange={(e) => setFormData({ ...formData, order: parseInt(e.target.value) })}
                  min="0" className={`w-full px-4 py-2 rounded-lg border ${isDarkMode ? 'bg-gray-700 border-gray-600 text-white' : 'bg-white border-gray-300'}`} />
              </div>
            </div>
          </>
        );

      default:
        return <p>Add form not available for this type</p>;
    }
  };

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center p-4" style={{ backgroundColor: 'rgba(0, 0, 0, 0.75)' }}>
      <div className={`max-w-2xl w-full rounded-xl shadow-2xl p-6 max-h-[90vh] overflow-y-auto ${isDarkMode ? 'bg-gray-800 border-gray-700' : 'bg-white border-gray-200'} border`}>
        <h3 className={`text-2xl font-bold mb-6 ${isDarkMode ? 'text-white' : 'text-gray-800'}`}>
          Add New {type === 'areas' ? 'Area' : type.slice(0, -1).charAt(0).toUpperCase() + type.slice(1, -1)}
        </h3>
        
        <div className="space-y-4">
          {renderFields()}
        </div>

        <div className="flex gap-3 mt-6">
          <button
            onClick={onClose}
            className={`flex-1 py-3 rounded-lg font-medium ${isDarkMode ? 'bg-gray-700 hover:bg-gray-600 text-gray-300' : 'bg-gray-200 hover:bg-gray-300 text-gray-700'}`}
          >
            Cancel
          </button>
          <button
            onClick={() => onSave(formData)}
            className="flex-1 py-3 bg-green-600 hover:bg-green-700 text-white rounded-lg font-medium"
          >
            Create
          </button>
        </div>
      </div>
    </div>
  );
};

// Delete Confirmation Modal
export const DeleteConfirm = ({ item, type, onConfirm, onCancel, isDarkMode }) => {
  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center p-4" style={{ backgroundColor: 'rgba(0, 0, 0, 0.75)' }}>
      <div className={`max-w-md w-full rounded-xl shadow-2xl p-6 ${isDarkMode ? 'bg-gray-800 border-gray-700' : 'bg-white border-gray-200'} border`}>
        <div className="text-center">
          <div className="text-6xl mb-4">⚠️</div>
          <h3 className={`text-2xl font-bold mb-3 ${isDarkMode ? 'text-white' : 'text-gray-800'}`}>
            Delete {type.slice(0, -1).charAt(0).toUpperCase() + type.slice(1, -1)}?
          </h3>
          <p className={`mb-6 ${isDarkMode ? 'text-gray-300' : 'text-gray-600'}`}>
            Are you sure you want to delete <strong>{item.name || item.name_english || 'this item'}</strong>? This action cannot be undone.
          </p>
          <div className="flex gap-3">
            <button
              onClick={onCancel}
              className={`flex-1 py-3 rounded-lg font-medium ${isDarkMode ? 'bg-gray-700 hover:bg-gray-600 text-gray-300' : 'bg-gray-200 hover:bg-gray-300 text-gray-700'}`}
            >
              Cancel
            </button>
            <button
              onClick={onConfirm}
              className="flex-1 py-3 bg-red-600 hover:bg-red-700 text-white rounded-lg font-medium"
            >
              Delete
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

// Edit Coins Modal
export const EditCoinsModal = ({ user, onSave, onClose, isDarkMode }) => {
  const [newAmount, setNewAmount] = useState(user.coins || 0);

  const handleSave = () => {
    onSave({
      user_id: user.user_id,
      new_amount: newAmount
    });
  };

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center p-4" style={{ backgroundColor: 'rgba(0, 0, 0, 0.75)' }}>
      <div className={`max-w-md w-full rounded-xl shadow-2xl p-6 ${isDarkMode ? 'bg-gray-800 border-gray-700' : 'bg-white border-gray-200'} border`}>
        <h3 className={`text-xl font-bold mb-4 ${isDarkMode ? 'text-white' : 'text-gray-800'}`}>
          ✏️ Edit User Coins
        </h3>
        
        <div className="space-y-3">
          <div>
            <label className={`block font-medium mb-1 text-sm ${isDarkMode ? 'text-gray-300' : 'text-gray-700'}`}>User Email</label>
            <div className={`px-3 py-2 rounded-lg text-sm ${isDarkMode ? 'bg-gray-700 text-white' : 'bg-gray-100 text-gray-800'}`}>
              {user.user_email || 'Unknown'}
            </div>
          </div>
          <div>
            <label className={`block font-medium mb-1 text-sm ${isDarkMode ? 'text-gray-300' : 'text-gray-700'}`}>Current Balance</label>
            <div className={`px-3 py-2 rounded-lg text-sm ${isDarkMode ? 'bg-gray-700 text-white' : 'bg-gray-100 text-gray-800'}`}>
              💰 {user.coins || 0} Tokens
            </div>
          </div>
          <div>
            <label className={`block font-medium mb-1 text-sm ${isDarkMode ? 'text-gray-300' : 'text-gray-700'}`}>Set New Amount</label>
            <input
              type="number"
              value={newAmount}
              onChange={(e) => setNewAmount(parseInt(e.target.value) || 0)}
              min="0"
              className={`w-full px-3 py-2 rounded-lg border text-sm ${isDarkMode ? 'bg-gray-700 border-gray-600 text-white' : 'bg-white border-gray-300'}`}
            />
          </div>
          <div className={`p-3 rounded-lg ${isDarkMode ? 'bg-blue-900 border-blue-700' : 'bg-blue-50 border-blue-200'} border`}>
            <p className={`text-sm font-bold ${isDarkMode ? 'text-blue-300' : 'text-blue-800'}`}>
              📊 Change: {newAmount - (user.coins || 0) >= 0 ? '+' : ''}{newAmount - (user.coins || 0)} Tokens
            </p>
            <p className={`text-xs mt-1 ${isDarkMode ? 'text-blue-400' : 'text-blue-700'}`}>
              Will be saved to database
            </p>
          </div>
        </div>

        <div className="flex gap-2 mt-4">
          <button
            onClick={onClose}
            className={`flex-1 py-2 rounded-lg font-medium text-sm ${isDarkMode ? 'bg-gray-700 hover:bg-gray-600 text-gray-300' : 'bg-gray-200 hover:bg-gray-300 text-gray-700'}`}
          >
            Cancel
          </button>
          <button
            onClick={handleSave}
            className="flex-1 py-2 bg-blue-600 hover:bg-blue-700 text-white rounded-lg font-medium text-sm"
          >
            Save Changes
          </button>
        </div>
      </div>
    </div>
  );
};

// Lock Confirm Modal
export const LockConfirmModal = ({ user, onConfirm, onCancel, isDarkMode }) => {
  const isLocked = user.wallet_locked === true;
  const action = isLocked ? 'Unlock' : 'Lock';
  const icon = isLocked ? '🔓' : '🔒';
  const color = isLocked ? 'green' : 'orange';

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center p-4" style={{ backgroundColor: 'rgba(0, 0, 0, 0.75)' }}>
      <div className={`max-w-md w-full rounded-xl shadow-2xl p-6 ${isDarkMode ? 'bg-gray-800 border-gray-700' : 'bg-white border-gray-200'} border`}>
        <div className="text-center">
          <div className="text-6xl mb-4">{icon}</div>
          <h3 className={`text-2xl font-bold mb-3 ${isDarkMode ? 'text-white' : 'text-gray-800'}`}>
            {action} Wallet?
          </h3>
          <p className={`mb-6 ${isDarkMode ? 'text-gray-300' : 'text-gray-600'}`}>
            {isLocked ? (
              <>
                Unlock wallet for <strong>{user.user_email}</strong>?
                <br />
                <span className="text-sm mt-2 block">
                  ✅ User can earn and spend Tokens<br />
                  ✅ Admin can edit Tokens
                </span>
              </>
            ) : (
              <>
                Lock wallet for <strong>{user.user_email}</strong>?
                <br />
                <span className="text-sm mt-2 block">
                  ❌ User cannot earn or spend Tokens<br />
                  ❌ Admin cannot edit Tokens<br />
                  🔒 Wallet will be frozen
                </span>
              </>
            )}
          </p>
          <div className="flex gap-3">
            <button
              onClick={onCancel}
              className={`flex-1 py-3 rounded-lg font-medium ${isDarkMode ? 'bg-gray-700 hover:bg-gray-600 text-gray-300' : 'bg-gray-200 hover:bg-gray-300 text-gray-700'}`}
            >
              Cancel
            </button>
            <button
              onClick={onConfirm}
              className={`flex-1 py-3 bg-${color}-600 hover:bg-${color}-700 text-white rounded-lg font-medium`}
              style={{
                backgroundColor: isLocked ? '#16a34a' : '#ea580c',
              }}
            >
              {action} Wallet
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

// Add Coins Modal
export const AddCoinsModal = ({ user, onSave, onClose, isDarkMode }) => {
  const [amount, setAmount] = useState(100);
  const [reason, setReason] = useState('');

  const handleSave = () => {
    onSave({
      user_id: user.user_id,
      amount: amount,
      reason: reason || 'Admin bonus'
    });
  };

  const newBalance = (user.coins || 0) + (amount || 0);

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center p-4" style={{ backgroundColor: 'rgba(0, 0, 0, 0.75)' }}>
      <div className={`max-w-md w-full rounded-xl shadow-2xl p-6 ${isDarkMode ? 'bg-gray-800 border-gray-700' : 'bg-white border-gray-200'} border`}>
        <h3 className={`text-xl font-bold mb-4 ${isDarkMode ? 'text-white' : 'text-gray-800'}`}>
          💰 Add Coins to User
        </h3>
        
        <div className="space-y-3">
          <div>
            <label className={`block font-medium mb-1 text-sm ${isDarkMode ? 'text-gray-300' : 'text-gray-700'}`}>User Email</label>
            <div className={`px-3 py-2 rounded-lg text-sm ${isDarkMode ? 'bg-gray-700 text-white' : 'bg-gray-100 text-gray-800'}`}>
              {user.user_email || 'Unknown'}
            </div>
          </div>
          <div>
            <label className={`block font-medium mb-1 text-sm ${isDarkMode ? 'text-gray-300' : 'text-gray-700'}`}>Current Balance</label>
            <div className={`px-3 py-2 rounded-lg text-sm ${isDarkMode ? 'bg-gray-700 text-white' : 'bg-gray-100 text-gray-800'}`}>
              💰 {user.coins || 0} Tokens
            </div>
          </div>
          <div>
            <label className={`block font-medium mb-1 text-sm ${isDarkMode ? 'text-gray-300' : 'text-gray-700'}`}>Amount to Add</label>
            <input
              type="number"
              value={amount}
              onChange={(e) => setAmount(parseInt(e.target.value) || 0)}
              min="1"
              className={`w-full px-3 py-2 rounded-lg border text-sm ${isDarkMode ? 'bg-gray-700 border-gray-600 text-white' : 'bg-white border-gray-300'}`}
            />
          </div>
          <div>
            <label className={`block font-medium mb-1 text-sm ${isDarkMode ? 'text-gray-300' : 'text-gray-700'}`}>Reason (Optional)</label>
            <input
              type="text"
              value={reason}
              onChange={(e) => setReason(e.target.value)}
              placeholder="e.g., Bonus reward"
              className={`w-full px-3 py-2 rounded-lg border text-sm ${isDarkMode ? 'bg-gray-700 border-gray-600 text-white' : 'bg-white border-gray-300'}`}
            />
          </div>
          <div className={`p-3 rounded-lg ${isDarkMode ? 'bg-green-900 border-green-700' : 'bg-green-50 border-green-200'} border`}>
            <p className={`text-sm font-bold ${isDarkMode ? 'text-green-300' : 'text-green-800'}`}>
              ✨ New Balance: {newBalance} Tokens
            </p>
            <p className={`text-xs mt-1 ${isDarkMode ? 'text-green-400' : 'text-green-700'}`}>
              +{amount || 0} Tokens will be added
            </p>
          </div>
        </div>

        <div className="flex gap-2 mt-4">
          <button
            onClick={onClose}
            className={`flex-1 py-2 rounded-lg font-medium text-sm ${isDarkMode ? 'bg-gray-700 hover:bg-gray-600 text-gray-300' : 'bg-gray-200 hover:bg-gray-300 text-gray-700'}`}
          >
            Cancel
          </button>
          <button
            onClick={handleSave}
            className="flex-1 py-2 bg-green-600 hover:bg-green-700 text-white rounded-lg font-medium text-sm"
          >
            Add Coins
          </button>
        </div>
      </div>
    </div>
  );
};
